import { memo } from 'react'
import { useI18n } from '../i18n/I18nContext'

interface PaginationProps {
  currentPage: number
  totalPages: number
  total: number
  onPageChange: (page: number) => void
  loading: boolean
}

export const Pagination = memo(function Pagination({
  currentPage,
  totalPages,
  total,
  onPageChange,
  loading,
}: PaginationProps) {
  const { t } = useI18n()
  const canGoPrevious = currentPage > 1 && !loading
  const canGoNext = currentPage < totalPages && !loading

  return (
    <div className="pagination">
      <button
        className="pagination-btn"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={!canGoPrevious}
        aria-label={t('pagination.prevAria')}
      >
        {t('pagination.prev')}
      </button>

      <div className="pagination-info">
        <span className="pagination-text">
          {t('pagination.pageOf', { current: currentPage, total: totalPages })}
        </span>
        <span className="pagination-total">
          {t('pagination.totalRepos', { total: total.toLocaleString() })}
        </span>
      </div>

      <button
        className="pagination-btn"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={!canGoNext}
        aria-label={t('pagination.nextAria')}
      >
        {t('pagination.next')}
      </button>
    </div>
  )
})
